import type { AttributeValue, Tracer } from '@opentelemetry/api'
import {
  ATTRIBUTE_NAME_AGENT_STATE_JSON,
  ATTRIBUTE_NAME_AGENT_STATE_REDACTED_PATHS_JSON,
  ATTRIBUTE_NAME_DECISION_MATCHED_RULE_COUNT,
  ATTRIBUTE_NAME_DECISION_OUTCOME,
  ATTRIBUTE_NAME_DECISION_REASON,
  ATTRIBUTE_NAME_ERROR_MESSAGE,
  ATTRIBUTE_NAME_ERROR_TYPE,
  ATTRIBUTE_NAME_FRISK_TOOL_ID,
  ATTRIBUTE_NAME_FRISK_TOOL_VERSION_ID,
  ATTRIBUTE_NAME_LLM_REASONING,
  ATTRIBUTE_NAME_SESSION_ID,
  ATTRIBUTE_NAME_TOOL_ARGS_JSON,
  ATTRIBUTE_NAME_TOOL_ARGS_REDACTED_PATHS_JSON,
  ATTRIBUTE_NAME_TOOL_CALL_ID,
  ATTRIBUTE_NAME_TOOL_NAME,
  SPAN_NAME_DECIDE_TOOL_CALL,
} from '../../telemetry/constants'
import { FriskSpan } from './frisk-span'

const FIELDS = {
  sessionId: ATTRIBUTE_NAME_SESSION_ID,
  toolName: ATTRIBUTE_NAME_TOOL_NAME,
  toolCallId: ATTRIBUTE_NAME_TOOL_CALL_ID,
  toolArgsJson: ATTRIBUTE_NAME_TOOL_ARGS_JSON,
  toolArgsRedactedPathsJson: ATTRIBUTE_NAME_TOOL_ARGS_REDACTED_PATHS_JSON,
  agentStateJson: ATTRIBUTE_NAME_AGENT_STATE_JSON,
  agentStateRedactedPathsJson: ATTRIBUTE_NAME_AGENT_STATE_REDACTED_PATHS_JSON,
  friskToolId: ATTRIBUTE_NAME_FRISK_TOOL_ID,
  friskToolVersionId: ATTRIBUTE_NAME_FRISK_TOOL_VERSION_ID,
  llmReasoning: ATTRIBUTE_NAME_LLM_REASONING,
  decisionOutcome: ATTRIBUTE_NAME_DECISION_OUTCOME,
  decisionMatchedRuleCount: ATTRIBUTE_NAME_DECISION_MATCHED_RULE_COUNT,
  decisionReason: ATTRIBUTE_NAME_DECISION_REASON,
  errorType: ATTRIBUTE_NAME_ERROR_TYPE,
  errorMessage: ATTRIBUTE_NAME_ERROR_MESSAGE,
} as const

/** Typed span for a tool-call policy decision. */
export class ToolCallDecisionSpan extends FriskSpan {
  constructor(args: { tracer: Tracer; parent?: FriskSpan | null }) {
    super({
      ...args,
      spanName: SPAN_NAME_DECIDE_TOOL_CALL,
      attributeFields: FIELDS,
    })
  }

  setAttributes(values: {
    sessionId?: string
    toolName?: string
    toolCallId?: string
    toolArgsJson?: string
    toolArgsRedactedPathsJson?: string
    agentStateJson?: string
    agentStateRedactedPathsJson?: string
    friskToolId?: string
    friskToolVersionId?: string
    llmReasoning?: string
    decisionOutcome?: string
    decisionMatchedRuleCount?: number
    decisionReason?: string
    errorType?: string
    errorMessage?: string
  }): void {
    this.setAttributesByField(
      values as Record<string, AttributeValue | undefined>,
    )
  }
}
